import {
  Button,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  Divider,
} from '@chakra-ui/react';
import React from 'react';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

type SearchPopoverProps = {
  onClear: () => void;
  onSearch: () => void;
  bodyChildren: React.ReactNode | React.ReactNode[];
  dropdownTitle?: string;
  buttonLabel?: string;
};
export const SearchPopover = ({
  dropdownTitle,
  buttonLabel,
  bodyChildren,
  onClear,
  onSearch,
}: SearchPopoverProps) => {
  const initialFocusRef = React.useRef(null);

  return (
    <Popover initialFocusRef={initialFocusRef} placement="bottom">
      <PopoverTrigger>
        <Button
          variant="outline"
          colorScheme="aurora"
          leftIcon={<Icon icon="search" />}
        >
          {buttonLabel || 'Search'}
        </Button>
      </PopoverTrigger>
      <PopoverContent bgColor={colors.millet[50]} p="24px" w="400px">
        <PopoverHeader pt={4} fontWeight="bold" border="0">
          {dropdownTitle || 'Search'}
        </PopoverHeader>
        <PopoverBody m="24px 0">{bodyChildren}</PopoverBody>
        <Divider />
        <PopoverFooter
          border="0"
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gridColumnGap="24px"
          mt="24px"
        >
          <Button
            colorScheme="aurora"
            variant="outline"
            onClick={onClear}
            flexGrow={1}
          >
            Clear
          </Button>
          <Button
            colorScheme="aurora"
            variant="solid"
            ref={initialFocusRef}
            onClick={onSearch}
            flexGrow={1}
          >
            Search
          </Button>
        </PopoverFooter>
      </PopoverContent>
    </Popover>
  );
};
